// queries.js

import { gql } from "@apollo/client";

export const GET_CLIENT_TRANSACTIONS_QUERY = gql`
  query (
    $clientId: Int!
    $first: Int
    $skip: Int
    $sortField: String
    $sortOrder: String
  ) {
    clientTransactions(
      clientId: $clientId
      first: $first
      skip: $skip
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      currentPage
      hasNextPage
      hasPreviousPage
      totalPages
      totalRecords
      items {
        amount
        id
        purchaseType
        success
        timestamp
        platform
        vendor
        client {
          id
          name
        }
      }
    }
  }
`;

export const GET_TRANSACTIONS_QUERY = gql`
  query (
    $search: String
    $success: Boolean
    $platform: [String]
    $vendor: [String]
    $purchaseType: [String]
    $grid: [String]
    $first: Int
    $skip: Int
    $sortField: String
    $sortOrder: String
  ) {
    transactions(
      search: $search
      success: $success
      platform: $platform
      vendor: $vendor
      purchaseType: $purchaseType
      grid: $grid
      first: $first
      skip: $skip
      sortField: $sortField
      sortOrder: $sortOrder
    ) {
      currentPage
      hasNextPage
      hasPreviousPage
      totalPages
      totalRecords
      items {
        id
        amount
        platform
        purchaseType
        success
        timestamp
        vendor
        transactionId
        voucherPin
        voucherSerial
        grid
        errors
        client {
          clientId
        }
      }
    }
  }
`;
